import api from '@/api';

type UTM = {
  utm_campaign: string;
  utm_medium: string;
  utm_source: string;
};

export const offerExpress = async (
  saleID: number,
  planID: number,
  utm: UTM,
): Promise<number> => {
  const { data } = await api.post('/core/vendas/oferta-express', {
    venda_id: saleID,
    plano: planID,
    ...utm,
  });

  return data.venda_id;
};
